<template>
  <div>
    <News />

    <Footer v-if="items != ''" />
  </div>
</template>

<script>
import News from "../components/News/News.vue";
import Footer from "../components/Footer.vue";
export default {
  components: {
    News,
    Footer,
  },
};
</script>

<style lang="scss" scoped></style>
